"use client";
import React, { useContext, useState } from "react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import useRefferalHook from "../../../hooks/useRefferal.hook";
import { ContextData, storeAssigned } from "@/services/Methods/normalMethods";
import Loader from "@/comman/Loader";
import { b_logo, Faimly, MainImage, MainImageNew, runningImage, videoImage } from "@/assets/images";
import Image from "next/image";
import ProductSection from "@/comman/Homepages/ProductSection";
import WellnessBusinessSection from "@/comman/Homepages/WellnessBusinessSection";
import SliderSection from "@/comman/Homepages/SliderSection";
import { useRouter } from "next/navigation";
const Home = (props) => {

  const data = useContext(ContextData);
  const router = useRouter();
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);
  const { isReferralLoading } = useRefferalHook({ ...props, ...data }, 'urlRefferalCheck');
  const handleProducts = () => {
    router.push(`/${storeAssigned()}/products`);
  }
  const handleLifestyle = () => {
    router.push(`/${storeAssigned()}/lifestyle`);
  }
  return (
    isReferralLoading ? (
      <Loader />
    ) : (
      <>
        <section className="banner_main relative h-[80vh] mt-[100px]">
          <div className="img-banner absolute top-0 left-0 h-full w-full">

            <Image className="w-full h-full homepage-banner-images xl:rounded-[0_0_40px_40px] rounded-[0_0_20px_20px] object-[70%_100%]" src={MainImageNew} alt="Image" style={{ objectFit: "cover" }} />
          </div>
          <div className="container mx-auto px-[15px] relative z-1 h-[100%]">
            <div className="discription-text h-full flex flex-col justify-center md:py-[120px] p-[100px_0_80px]">
              <div className="text-content md:max-w-[60%] max-w-[500px]">
                <h1 className="text-white xl:text-[60px] lg:text-[50px] md:text-[40px] text-[35px] font-semibold mb-[25px] leading-[1.2]">
                  what's your b:?
                </h1>
                <h2 className="text-white xl:text-[30px] lg:text-[28px] md:text-[24px] text-[20px] font-medium mb-[16px] leading-[1.2]">
                  Be bold. Be strong. Be well.
                </h2>
                <p className="text-white 2xl:text-[29px] xl:text-[25px] lg:text-[20px] text-[16px] leading-[1.2] mb-[45px]  font-normal">
                  b:hip is where exceptional wellness meets purpose— empowering you to design your life, your health, <br /> and your impact.
                </p>
                <div className="button-wrap-banner flex md:gap-[20px] gap-[15px] lg:flex-row flex-col">
                  <button className="flex items-center gap-2 bg-[#0388c7] hover:bg-[#036c9c] text-white p-[6px_6px_6px_20px] rounded-[50px] !no-underline font-bold transition-all duration-300 text-[16px] xl:text-[24px] text-[20px] lg:max-w-[320px] max-w-[260px] w-full flex justify-center" onClick={handleProducts}>
                    <span className="flex-1">explore products</span>
                    <span className="inline-block ml-auto xl:w-[50px] xl:h-[50px] w-[35px] h-[35px] rounded-[50%] xl:p-[10px] p-[6px] flex  justify-center items-center bg-white">
                      {/* <svg className="w-10 h-10" fill="#0388c7" viewBox="0 0 20 20">
                        <path d="M3 1a1 1 0 000 2h1.22l.305 1.222a.997.997 0 00.01.042l1.358 5.43-.893.892C3.74 11.846 4.632 14 6.414 14H15a1 1 0 000-2H6.414l1-1H14a1 1 0 00.894-.553l3-6A1 1 0 0017 3H6.28l-.31-1.243A1 1 0 005 1H3zM16 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM6.5 18a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" />
                      </svg> */}
                      <img src="/images/cart-mian.png" alt="" />
                    </span>
                  </button>



                  <button className="flex px-[15px] items-center bg-transparent text-white p-[6px] rounded-[50px] !no-underline font-bold transition-all duration-300 text-[16px] xl:text-[24px] text-[20px] lg:max-w-[320px] max-w-[260px] w-full flex justify-center border border-[2px] border-#fff hover:bg-[#0388c7] hover:border-[#0388c7]" onClick={handleLifestyle}>
                    <span>join the movement</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="built-sec py-[60px] bg-white">
          <div className="container mx-auto xl:max-w-[1264px] px-[15px]">
            <div className="flex flex-col">
              {/* Text Content Section */}
              <div className="text-content mb-8 text-center">
                <h2 className="text-black xl:text-[50px] lg:text-[50px] md:text-[40px] text-[32px] font-semibold mb-4">
                  b:hip =
                </h2>
                <h2 className="text-black xl:text-[50 px] lg:text-[28px] md:text-[24px] text-[20px] font-semibold mb-6">
                  Helping • Impact • People
                </h2>
                <p className="text-black xl:text-[  px] lg:text-[16px] md:text-[14px] text-[12px] leading-relaxed mb-4">
                  We believe wellness is more than what you take—it's what you create.
                </p>
                <p className="text-black xl:text-[18px] lg:text-[16px] md:text-[14px] text-[12px] leading-relaxed">
                  b:hip connects purpose-driven people through products that transform health,
                  <br />
                  opportunity that transforms lives, and a community that lifts others up.
                </p>
              </div>

              {/* Video Player Section */}
              <div className="video-section">
                <div className="relative w-full max-w-[1100px] mx-auto">
                  <div className="relative rounded-2xl overflow-hidden bg-black aspect-video">
                    {isVideoPlaying ? (
                      <iframe
                        className="absolute top-0 left-0 w-full h-full"
                        src="https://www.youtube.com/embed/8x-CKX0UmkQ?rel=0&modestbranding=1&playsinline=1&autoplay=1&mute=1"
                        title="YouTube video player"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerPolicy="strict-origin-when-cross-origin"
                        allowFullScreen
                      />
                    ) : (
                      <button
                        type="button"
                        aria-label="Play video"
                        className="group absolute inset-0 w-full h-full"
                        onClick={() => setIsVideoPlaying(true)}
                      >
                        <Image className="w-full h-full object-cover" src={videoImage} alt="Video thumbnail" />
                        <span className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 inline-flex items-center justify-center rounded-full bg-white/90 group-hover:bg-white w-[50px] h-[50px] md:w-[80px] md:h-[80px] transition-colors">
                          <img className="w-[50px] h-[50px] md:w-[80px] md:h-[80px]" src="/images/video-icon.png" alt="Play" />
                        </span>
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Mission Section */}
        <section className="mission-section relative h-[80vh]">
          <div className="img-banner absolute top-0 left-0 h-full w-full">
            <div className="absolute top-0 left-0 bg-[#ffffff9c] w-full h-full md:hidden"></div>
            <Image src={runningImage} alt="Running Image" className="w-full h-full object-cover rounded-tl-lg rounded-tr-lg object-[80%_100%]" />
          </div>
          <div className="container mx-auto px-[15px] relative z-1 h-[100%]">
            <div className="discription-text h-full flex flex-col justify-center md:py-[120px] p-[100px_0_80px]">
              <div className="text-content md:max-w-[58%]">

                <h2 className="text-black xl:text-[30px] lg:text-[18px] text-[16px]  leading-[1.5] mb-[45px] font-[400]">
                  <b> Our mission is simple:</b>  Help people around the world become the very best they can be—while helping others do the same.
                </h2>
                <div className="button-wrap-mission flex md:gap-[20px] gap-[15px] flex-wrap">
                  <button className="flex items-center gap-2 bg-[#0388c7] hover:bg-[#036897] text-white p-[9px_30px_9px_30px] rounded-[50px] !no-underline font-bold transition-all duration-300 text-[16px] xl:text-[25px] md:text-[20px] max-w-max  w-full flex justify-center">
                    <span>discover b:hip</span>
                  </button>
                  <button className="flex items-center bg-transparent text-[#0388c7] p-[9px_30px] rounded-[50px] !no-underline font-bold transition-all duration-300 text-[16px] xl:text-[25px] md:text-[20px] max-w-max w-full flex justify-center border border-[3px] border-[#0388c7]">
                    <span>meet our community</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>

        <ProductSection />
        <WellnessBusinessSection />
        <SliderSection />
      </>
    ))
};
export default Home;